// Chakra imports
import {Box, Button, Flex, Icon, Spinner, Text, useColorModeValue,} from "@chakra-ui/react";
import Card from "../card/Card.jsx";
// Custom components
import BarChart from "./BarChart.jsx";
import React from "react";
import {barChartOptionsConsumption} from "../../variables/charts.js";
import {MdBarChart} from "react-icons/md";

export default function MonthlyTraffic(props) {
    const {chartData, isLoading, ...rest} = props;
    // Chakra Color Mode
    const textColor = useColorModeValue("secondaryGray.900", "white");
    const iconColor = useColorModeValue("brand.500", "white");
    const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
    const bgHover = useColorModeValue(
        {bg: "secondaryGray.400"},
        {bg: "whiteAlpha.50"}
    );
    const bgFocus = useColorModeValue(
        {bg: "secondaryGray.300"},
        {bg: "whiteAlpha.100"}
    );

    // function getLast30DayNumbers() {
    //     const days = [];
    //     const today = new Date();
    //
    //     for (let i = 29; i >= 0; i--) {
    //         const day = new Date(today);
    //         day.setDate(today.getDate() - i);
    //         days.push(day.getDate()); // just the day of the month
    //     }
    //
    //     return days;
    // }

    function getAllDaysInCurrentMonth() {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth(); // 0-based

        const daysInMonth = new Date(year, month + 1, 0).getDate();

        return Array.from({length: daysInMonth}, (_, i) => i + 1);
    }


    const chartOptions = JSON.parse(JSON.stringify(barChartOptionsConsumption))
    chartOptions.xaxis.categories = getAllDaysInCurrentMonth()

    return (
        <Card align='center' direction='column' w='100%' {...rest}>
            <Flex align='center' w='100%' px='15px' py='10px'>
                <Text
                    me='auto'
                    color={textColor}
                    fontSize='xl'
                    fontWeight='700'
                    lineHeight='100%'>
                    Monthly visit
                </Text>
                <Button
                    align='center'
                    justifyContent='center'
                    bg={bgButton}
                    _hover={bgHover}
                    _focus={bgFocus}
                    _active={bgFocus}
                    w='37px'
                    h='37px'
                    lineHeight='100%'
                    borderRadius='10px'
                    {...rest}>
                    <Icon as={MdBarChart} color={iconColor} w='24px' h='24px'/>
                </Button>
            </Flex>

            <Box h='240px' mt='auto'>
                {!isLoading ? <BarChart
                    chartData={chartData}
                    chartOptions={chartOptions}
                /> : (<Box display="flex" justifyContent="center" alignItems="center" height="200px">
                    <Spinner size="xl" color="blue"/>
                </Box>)
                }
            </Box>
        </Card>
    );
}
